import { useMemo } from 'react';
import type { WpBonusGroup } from '@/api/cms/progressiveBonuses';
import { useCMSProgressiveBonuses } from '@/modules/bonuses/hooks/useCMSProgressiveBonuses';
import { useGetCommonStore } from '@/store';

const EMPTY_GROUPS: WpBonusGroup[] = [];

export const useProgressiveOfferBonuses = () => {
  const useCommonStore = useGetCommonStore();
  const currentWallet = useCommonStore.use.currentWallet();

  const { bonusGroups, isLoading } = useCMSProgressiveBonuses();

  const progressiveBonusGroups = useMemo(() => {
    if (currentWallet?.isCrypto) return EMPTY_GROUPS;
    return bonusGroups;
  }, [currentWallet?.isCrypto, bonusGroups]);

  const hasCMSProgressiveData = useMemo(
    () =>
      !!progressiveBonusGroups.length &&
      progressiveBonusGroups.some((g) => !!g.bonuses.length),
    [progressiveBonusGroups]
  );

  return {
    progressiveBonusGroups,
    isLoading: currentWallet?.isCrypto ? false : isLoading,
    hasCMSProgressiveData,
  };
};
